import PropTypes from 'prop-types';
import React from 'react';

import AgentChart, { AgentChartData } from './agent_chart';
import { CELL_HEIGHT, CELL_PADDING, MIN_CELL_WIDTH } from './report_table';
import connect from 'components/lib/connect';
import ReportChannel from 'models/reports/report_channel';
import SharedTable from './shared_table';

const SPARKLINE_HPADDING = 8;
const SPARKLINE_VPADDING = 20;

export function AgentTable({
  highlight,
  days,
  windowWidth,
  aggregationLevel,
  report,
  channel,
  getResponseCol,
  getAgentEmail,
  getAgentNameOrEmail,
}) {
  // pass the sparkline column into the SharedTable
  let extraColumn = {
    header: 'Sparkline',
    renderCell(props) {
      if (this.state.sortedRows.length === 0) {
        return null;
      }
      let agentId = this.state.isPaginated
        ? this.state.sortedRowsForPage[props.rowIndex]
        : this.state.sortedRows[props.rowIndex];
      let values = this.props.days.map(day => this.props.report.getDataForDayAndId(day, agentId));

      return (
        <AgentChart
          data={new AgentChartData({ days: this.props.days, values })}
          highlight={this.props.highlight}
          height={CELL_HEIGHT - 2 * CELL_PADDING}
          hPadding={SPARKLINE_HPADDING}
          vPadding={SPARKLINE_VPADDING}
          width={MIN_CELL_WIDTH - 2 * CELL_PADDING}
        />
      );
    },
    unsortable: true,
    noPadding: true,
  };

  return (
    <div className="reportTable-container">
      <SharedTable
        name="Agents"
        report={report}
        days={days}
        columnNames={['Name', getResponseCol(channel)]}
        getNameForId={getAgentNameOrEmail}
        getTitleForId={getAgentEmail}
        extraColumn={extraColumn}
        windowWidth={windowWidth}
        highlight={highlight}
        aggregationLevel={aggregationLevel}
        shouldPaginate
      />
    </div>
  );
}

AgentTable.propTypes = {
  highlight: PropTypes.object,
  days: PropTypes.arrayOf(PropTypes.string),
  windowWidth: PropTypes.number,
  aggregationLevel: PropTypes.string,
  report: PropTypes.object,
  channel: PropTypes.string,

  getAgentEmail: PropTypes.func,
  getAgentNameOrEmail: PropTypes.func,
  getResponseCol: PropTypes.func,
};

function mapStateToProps({ getProvider }, { highlight, days, channel, report, windowWidth, aggregationLevel }) {
  const agentsProvider = getProvider('agents');

  function getAgentNameOrEmail(agentId) {
    let agent = agentsProvider.findBy({ id: agentId });
    return agent ? agent.getDisplayName() : '';
  }

  function getAgentEmail(agentId) {
    let agent = agentsProvider.findBy({ id: agentId });
    return agent ? agent.email : '';
  }

  function getResponseCol(responseChannel) {
    switch (responseChannel) {
      case ReportChannel.EMAIL:
        return 'Total Outgoing Emails';
      case ReportChannel.PHONE_CALL:
        return 'Total Calls';
      case ReportChannel.SMS:
        return 'Total Outgoing SMSs';
      case ReportChannel.FB_MESSENGER:
        return 'Total Outgoing FB Messages';
      case ReportChannel.CHAT_SESSION:
        return 'Total Chats';
      default:
        return 'Total Responses';
    }
  }

  return {
    highlight,
    days,
    channel,
    report,
    windowWidth,
    aggregationLevel,
    getAgentNameOrEmail,
    getAgentEmail,
    getResponseCol,
  };
}

const AgentTableContainer = connect(mapStateToProps)(AgentTable);

export default AgentTableContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/reporting/report/lib/agent_table.jsx